import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const SquareAcademicCapIcon = ({ className }) => (_jsx("svg", Object.assign({ className: `svg-square-academic-cap-icon ${className}`, height: '13.214', viewBox: '0 0 16.15 13.214', width: '16.15', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("path", { d: 'M3.936,10.473v2.936l5.139,2.8,5.139-2.8V10.473l-5.139,2.8ZM9.075,3,1,7.4l8.075,4.4,6.607-3.6v5.073H17.15V7.4Z', fill: '#70bbd8', transform: 'translate(-1 -3)' }) })));
SquareAcademicCapIcon.propTypes = {
    className: propStr(),
};
SquareAcademicCapIcon.defaultProps = {
    className: '',
};
export default SquareAcademicCapIcon;
